// src/screens/DailyStreakScreen.tsx

import iconHeader from '@/assets/png/daily-streak.png';
import { ExpandableText } from '@/components/ExpandableText';
import Loading from '@/components/loading/skeleton';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTradingCampaignDailyStreak } from '../hooks/useTradingCampaigns';
import StreakGrid from './StreakGrid';

// --- Header Component ---
const Header: React.FC = () => {
    const { data, isLoading } = useTradingCampaignDailyStreak();

    const { i18n } = useTranslation();
    return (
        <header className="flex justify-between items-start pb-4 ">
            <Loading
                isLoading={isLoading}
                className={clsx('min-h-[60px] flex-1', {
                    '!w-[200px]': isLoading,
                })}
            >
                <div className="text-white break-words max-w-[calc(100%-82px)]">
                    <h1 className="text-xl font-medium block break-words">
                        {data?.campaign.title?.[i18n.language] ||
                            data?.campaign.title?.en}
                    </h1>

                    <ExpandableText
                        text={
                            data?.campaign?.description?.[i18n.language] ||
                            data?.campaign?.description?.en ||
                            ''
                        }
                    />
                </div>
            </Loading>

            <div className="w-[82px] h-[82px] shrink-0">
                <img src={iconHeader} alt="" />
            </div>
        </header>
    );
};

// --- Main Screen Component ---
const DailyStreakScreen: React.FC = () => {
    return (
        // Áp dụng Dark Mode nền đen cho toàn bộ màn hình
        <div className="bg-black h-[60vh] mb-10 px-4 pt-2 flex flex-col justify-between">
            <div className="flex flex-col">
                <Header />
                <div className=" h-[1px] bg-[#1F1F1F] mb-4 mx-[-16px]" />
                <StreakGrid />
            </div>
        </div>
    );
};

export default DailyStreakScreen;
